import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

export interface TabItem {
  label: string;
  href: string;
  isExact?: boolean;
  isHighlighted?: boolean;
}

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLinkActive, RouterLink, NgClass],
  standalone: true,
})
export class TabsComponent {
  @Input() noHorizontalOffset = false;

  @Input() tabItems!: TabItem[] | null;
}
